import { getTwoDiagnosesCorrelatedMeasures } from "../../api/calls";

/**
 * Diagnosis-vs-rest correlation of every measure, one row per diagnosis.
 * Patient-independent, so it only needs loading once.
 *
 * @param diagnosisNames Diagnoses to correlate against
 * @param signal Abort signal
 * @returns number[<diagnosisNames>][<measureNames>]
 */
export const loadCorrelationsBundle = async (diagnosisNames: string[], signal?: AbortSignal): Promise<number[][]> => {
  return Promise.all(
    diagnosisNames.map((diagnosis: string) => {
      return getTwoDiagnosesCorrelatedMeasures({
        filterParams1: {equal: {[diagnosis]: true}},
        filterParams2: {equal: {[diagnosis]: false}},
      }, signal);
    })
  );
};
